import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Navbar } from '@/components/layout/navbar'
import { AuthProvider } from '@/components/auth/auth-provider'
import { AdminRoute } from '@/components/auth/admin-route'
import { ProductsPage } from '@/pages/products'
import { ProductDetailsPage } from '@/pages/products/[id]'
import { CartPage } from '@/pages/cart'
import { WishlistPage } from '@/pages/wishlist'
import { SellerDashboard } from '@/pages/seller/dashboard'
import { SellerRegisterPage } from '@/pages/seller/register'
import { SellerApplicationStatus } from '@/pages/seller/application-status'
import { StoreProfilePage } from '@/pages/seller/store-profile'
import { DeliveryRegisterPage } from '@/pages/delivery/register'
import { DeliveryApplicationStatus } from '@/pages/delivery/application-status'
import DeliveryDashboard from '@/pages/delivery/dashboard'
import { ProductGrid } from '@/components/products/product-grid'
import { LoginPage } from '@/pages/auth/login'
import { RegisterPage } from '@/pages/auth/register'
import { AuthCallbackPage } from '@/pages/auth/callback'
import { ResetPasswordPage } from '@/pages/auth/reset-password'
import { VideosPage } from '@/pages/videos'
import { NewVideoPage } from '@/pages/videos/new'
import { VideoDetailsPage } from '@/pages/videos/[id]'
import { AdminDashboard } from '@/pages/admin/dashboard'
import { AdminProductsPage } from '@/pages/admin/products'
import { AdminSellersPage } from '@/pages/admin/sellers'
import { DeliveryPartnersPage } from '@/pages/admin/delivery-partners'
import { AdminDeliveriesPage } from '@/pages/admin/deliveries'
import { AdminUsersPage } from '@/pages/admin/users'
import { AdminPaymentsPage } from '@/pages/admin/payments'
import { AdminPaymentHistory } from '@/pages/admin/payment-history'
import { AdminOrdersPage } from '@/pages/admin/orders'
import { AdminCompetitionsPage } from '@/pages/admin/competitions'
import { AdminVideosPage } from '@/pages/admin/videos'
import { AdminLoansPage } from '@/pages/admin/loans'
import { AdminAdvertisementsPage } from '@/pages/admin/advertisements'
import { ManagerDeptPage } from '@/pages/admin/manager-dept'
import { ProfilePage } from '@/pages/profile'
import { SettingsPage } from '@/pages/settings'
import { ManagementPage } from '@/pages/management'
import { ManagerCompetitionsPage } from '@/pages/management/competitions'
import { ManagementDeliveriesPage } from '@/pages/management/deliveries'
import { ManagementTeamPage } from '@/pages/management/team'
import { DeliveryCompetitionsPage } from '@/pages/delivery/competitions'
import { LanguageProvider } from '@/lib/context/LanguageContext'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { OrderTrackingPage } from '@/pages/orders/tracking'
import { HeroSection } from '@/components/home/HeroSection'
import { CategorySection } from '@/components/home/CategorySection'
import { FeaturedProducts } from '@/components/home/FeaturedProducts'
import { TestimonialsSection } from '@/components/home/TestimonialsSection'
import { StatisticsSection } from '@/components/home/StatisticsSection'
import { HowItWorksSection } from '@/components/home/HowItWorksSection'
import { ContactPage } from '@/pages/contact'
import { ThanksPage } from '@/pages/thanks'
import { AdBanner } from '@/components/advertisements/AdBanner'
import { FAQsPage } from '@/pages/faqs'
import { PrivacyPolicyPage } from '@/pages/privacy'
import { NotificationProvider } from '@/components/notifications/NotificationProvider'
import { Footer } from '@/components/layout/Footer'
import { SellerStorePage } from '@/pages/seller/[id]'

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <div className="pt-16 flex-grow"> {/* Add padding-top to account for fixed navbar */}
                <AdBanner />
                <Routes>
                  {/* Admin Routes */}
                  <Route
                    path="/admin"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminDashboard />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/products"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminProductsPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/orders"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminOrdersPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/sellers"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminSellersPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/delivery-partners"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <DeliveryPartnersPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/deliveries"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminDeliveriesPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/users"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminUsersPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/payments"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminPaymentsPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/payment-history"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminPaymentHistory />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/competitions"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminCompetitionsPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/videos"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminVideosPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/loans"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminLoansPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/advertisements"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <AdminAdvertisementsPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/manager-dept"
                    element={
                      <AdminRoute>
                        <div className="min-h-screen bg-gray-50">
                          <ManagerDeptPage />
                        </div>
                      </AdminRoute>
                    }
                  />
                  
                  {/* Auth Routes */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/auth/callback" element={<AuthCallbackPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  
                  {/* Public Routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/products/:id" element={<ProductDetailsPage />} />
                  <Route path="/seller/:id" element={<SellerStorePage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/seller/dashboard" element={<SellerDashboard />} />
                  <Route path="/seller/store-profile" element={<StoreProfilePage />} />
                  <Route path="/seller/register" element={<SellerRegisterPage />} />
                  <Route path="/seller/application-status" element={<SellerApplicationStatus />} />
                  <Route path="/delivery/register" element={<DeliveryRegisterPage />} />
                  <Route path="/delivery/application-status" element={<DeliveryApplicationStatus />} />
                  <Route path="/delivery/dashboard" element={<DeliveryDashboard />} />
                  <Route path="/delivery/competitions" element={<DeliveryCompetitionsPage />} />
                  <Route path="/videos" element={<VideosPage />} />
                  <Route path="/videos/new" element={<NewVideoPage />} />
                  <Route path="/videos/:id" element={<VideoDetailsPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/management" element={<ManagementPage />} />
                  <Route path="/management/competitions" element={<ManagerCompetitionsPage />} />
                  <Route path="/management/deliveries" element={<ManagementDeliveriesPage />} />
                  <Route path="/management/team" element={<ManagementTeamPage />} />
                  <Route path="/orders/tracking/:id" element={<OrderTrackingPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/thanks" element={<ThanksPage />} />
                  <Route path="/faqs" element={<FAQsPage />} />
                  <Route path="/privacy" element={<PrivacyPolicyPage />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </Router>
        </NotificationProvider>
      </AuthProvider>
    </LanguageProvider>
  )
}

function Home() {
  return (
    <>
      <HeroSection />
      <StatisticsSection />
      <CategorySection />
      <HowItWorksSection />
      <FeaturedProducts />
      <TestimonialsSection />
    </>
  )
}

export default App